const diagnosticosRoutes = [{
        path: '/diagnosticos/listar',
        name: 'ListarDiagnosticos',
        component: () =>
            import ('@/modules/diagnosticos/views/ListarDiagnosticos'),
        meta: { requiresAuth: true, domain: 'Diagnosticos', title: 'Listar diagnósticos', valid: ['RRHH', 'dev'], blockOnDisabled: true }
    },
    {
        path: '/diagnosticos/ver/:id',
        name: 'VerDiagnostico',
        component: () =>
            import ('@/modules/diagnosticos/views/VerDiagnostico'),
        meta: { requiresAuth: true, domain: 'Diagnosticos', title: 'Ver diagnóstico', valid: ['RRHH', 'dev'], blockOnDisabled: true }
    }
]

export default diagnosticosRoutes
